import Success from "./Success";
import {IResult} from "./types/IResult";

const _success: Success = new Success();
let _result: IResult<Success> | null = null;

export default class Result {
	/**
	 * Creates a new result in the faulted state, using the supplied errorValue as error.
	 * @returns A new IResult in the faulted state.
	 */
	static fromError<TResult>(error: string, status: number, data?: Record<string, any>): IResult<TResult> {
		return {$type: "faulted", error, status, data};
	}

	/**
	 * Creates a new result in succeeded state, using the supplied successValue as the result value.
	 * @param successValue The value to store in the result.
	 * @returns A new IResult in the succeeded state.
	 */
	static fromValue<TResult>(successValue: TResult): IResult<TResult> {
		return {$type: "succeeded", value: successValue};
	}

	/**
	 * Returns a singleton instance of a successful result with a Success value.
	 * @returns A singleton IResult<Success> in the succeeded state.
	 */
	static success(): IResult<Success> {
		return _result ??= this.fromValue<Success>(_success);
	}

	// /**
	//  * Creates a new result in the faulted state with a void-like Success type.
	//  * @returns A new IResult<Success> in the faulted state.
	//  */
	// static voidFromError(error: string, status: number, data?: Record<string, any>): IResult<Success> {
	// 	return this.fromError(error, status, data);
	// }
}
